import PropTypes from 'prop-types';

const EmergencyContact = {
  name: PropTypes.string,
  phoneNumber: PropTypes.string,
  email: PropTypes.string,
};

export const EmergencyContactShape = PropTypes.shape(EmergencyContact);
export const EmergencyContactExact = PropTypes.exact(EmergencyContact);
